import * as yup from "yup";
import { createValidationSchema, validate } from "@";

export const schema = createValidationSchema({
  title: validate("req", "title"),
  queryValue: validate("req", "queryValue"),
  affiliateId: validate("req", "affiliateId"),
  createCopies: yup.boolean().default(false),

  numberOfCopies: yup.string().when(["createCopies"], {
    is: true,
    then: () => yup.string().required().trim().min(1),
    otherwise: () => yup.string(),
  }),
});

export const defaultValues = {
  title: "",
  queryValue: "",
  affiliateId: null,
  numberOfCopies: 0,
  createCopies: false,
};
